import { SyntheticEvent } from 'react'

import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { getTestId } from '@utils/helpers'

type MenuItemFlatProps = {
	onClick: (e: SyntheticEvent) => void
	icon: IconDefinition
	text: string
	color?: string
}

export default function MenuItemFlat({
	onClick,
	icon,
	text,
	color = 'inherit',
	...rest
}: MenuItemFlatProps) {
	const testId = getTestId(rest)

	return (
		<MenuItem onClick={onClick} data-testid={testId} {...rest}>
			<ListItemIcon>
				<FontAwesomeIcon icon={icon} color={color} />
			</ListItemIcon>
			<ListItemText>{text}</ListItemText>
		</MenuItem>
	)
}
